module.exports = __webpack_public_path__ + "images/areamap/btn_mappin_hokkaido-tohoku_pc_760260f481944dc0dd3212debdf4fdcd.png";